import { Injectable } from '@angular/core';
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';
import { DialogPortfolioCustomLabelsModifyComponent } from '@irb/irb-dialogs/dialog-portfolio-custom-labels-modify/dialog-portfolio-custom-labels-modify.component';
import { TruncateTooltipCellComponent } from '@irb-common/components/grid/renderers/truncatetooltip.cell.component';
import { DialogPortfolioCustomLabelsModifyNoRowComponent } from '@irb/irb-dialogs/dialog-portfolio-custom-labels-modify/dialog-portfolio-custom-labels-modify.no-rows.component';
import { UtilityService } from '@irb-common/services/utility.service';

@Injectable({
    providedIn: 'root'
})
export class DialogPortfolioCustomLabelsModifyGridLayoutService implements GridLayoutService<DialogPortfolioCustomLabelsModifyComponent> {
    constructor(private util: UtilityService) {}

    getFrameworkComponents() {
        return {
            "TruncateTooltipCellComponent": TruncateTooltipCellComponent,
            "DialogPortfolioCustomLabelsModifyNoRowComponent": DialogPortfolioCustomLabelsModifyNoRowComponent
        };
    }

    getColumnDefs(parent: DialogPortfolioCustomLabelsModifyComponent) {
        return [
            {
                headerName: 'Select All',
                headerComponent: 'customHeader',
                cellRenderer : 'customHeader',
                cellRendererParams: {parentObject: parent, type: 'rowCheckBox' },
                suppressColumnsToolPanel: true,
                suppressSizeToFit: true,
                toolPanelClass: 'toolpanel-header-checkbox-hide',
                headerComponentParams: {parentObject: parent, type: 'headerCheckBox' },
                floatingFilterComponent: 'customHeader',
                floatingFilterComponentParams: { parentObject: parent, type: 'clearAllBtn', suppressFilterButton: true },
                suppressMovable: true,
                lockPosition: true,
                lockVisible: true,
                sortable: false,
                filter: true,
                resizable: false,
                minWidth: 25,
                width: 25,
                maxWidth:25,
                cellStyle: {'padding' : '5px 3px 0 2px'},
                headerClass: 'customHeaderClassSelectAll',
                cellClass: 'selectAllCheckBoxRecord'
            },
            {
                headerName: 'Label Name',
                field: 'name',
                flex: 1,
                minWidth: 250,
                cellRenderer: "TruncateTooltipCellComponent",
                filter: 'agTextColumnFilter',
                floatingFilterComponentParams: {suppressFilterButton: true},
                suppressMovable: true,
                sort: "asc",
                comparator: this.util.sortString.bind(parent)
            },
            {
                headerName: 'Label Description',
                field: 'description',
                flex: 1,
                cellRenderer: "TruncateTooltipCellComponent",
                filter: 'agTextColumnFilter',
                floatingFilterComponentParams: {suppressFilterButton: true},
                suppressMovable: true,
                comparator: this.util.sortString.bind(parent)
            }];
    }
}
